module.exports = __webpack_public_path__ + "img/8_34.fc45cdc5.png";